import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { CollectionServer, deleteInArray, GET, IfElse, Model, QueryDetail, QueryOrder, updateInArray } from 'fennec-ui'
import { errorCatch, POST } from 'fennec-ui'

export default function GorodaSerii(props) {
    const [loading, setLoading] = useState(false);
    const { auth, object, sourceKey, create } = props;
    const dispatch = useDispatch();

    const filters = () => [
        {
            label: "Город",
            name: "gorod",
            display: (item) => {
                return item.name
            },
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("name", "ASC")
            ],
            sort: true,
            filter: true,
        },
    ];

    return (
        <>
            <CollectionServer
                name={"GorodaSerii"}
                auth={auth}
                size="small"
                source={`/api/goroda-serii${(!create)?"/com":""}/byseriya/${object.ID}`}
                filters={filters}
                mode={"list"}
                render={(item, idx, { setCollection, setCollectionItem, update }) => {
                    return (
                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", width: "100%", paddingRight: "18px" }}>
                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span>{item?.gorod?.name}</span>
                                </div>
                            </div>
                        </div>
                    )
                }}
                collectionActions={() => [
                    ...IfElse(
                        (create == true), [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                let o = {
                                    seriyaID: object.ID,
                                    gorodID: values.gorodID,
                                }
                                POST(auth, `/api/serii/add-gorod`, o,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Город",
                                    name: "gorod",
                                    type: "object",
                                    relation: {
                                        display: (item) => {
                                            return item.name
                                        },
                                        reference: { object: "City", property: "ID" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryDetail("model"),
                                        QueryOrder("name", "ASC")
                                    ]
                                }
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить город",
                            modal: {
                                width: "600px",
                                title: "Добавить город",
                            }
                        }], []),
                ]}
                modelActions={(item) => [
                    ...IfElse(
                        (create == true), [
                        {
                            danger: true,
                            title: "Удалить",
                            action: (values, unlock, close, { collection, setCollection }) => {
                                GET(auth, `/api/gorod-serii/delete/${item.ID}`,
                                    () => setCollection(deleteInArray(collection, item)), errorCatch
                                );
                            },
                        }], []),
                ]}
            />
        </>
    );
}
